import React from 'react';

const File = () => {

  return (
    <svg width="31" height="37" viewBox="0 0 31 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_629_557)">
        <path d="M4 35H27C28.6569 35 30 33.6569 30 32V11.2426C30 10.447 29.6839 9.68393 29.1213 9.12132L20.8787 0.87868C20.3161 0.316071 19.553 0 18.7574 0H4C2.34315 0 1 1.34315 1 3V32C1 33.6569 2.34315 35 4 35Z" fill="white" />
      </g>
      <defs>
        <filter id="filter0_d_629_557" x="0" y="0" width="31" height="37" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.345833 0 0 0 0 0.345833 0 0 0 0 0.345833 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_629_557" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_629_557" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default File;